export class FeatureDisabledError extends Error {
    constructor() {
        super("Feature disabled");
        this.name = "FeatureDisabledError";
    }
}

export function isFeatureDisabledError(
    error: Error | null,
): error is FeatureDisabledError {
    return error instanceof FeatureDisabledError;
}
